import { Text } from "../Text/Text/Text";
import { jsx as _jsx } from "react/jsx-runtime";
export var Source = function Source(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_jsx(Text, {
    richText: true,
    typog: "bodycopy",
    children: text
  });
};